<template>
  <!-- 一个文件或者分享链接 -->
  <div class="oneFileFolder">
    <van-image class="leftIcon" fit="contain" :src="logoSrc(item)" />
    <template v-if="!item.folderId">
      <div class="folder_name">
        <div class="file" :class="{ isExpired: item.isExpired }">{{ item.title }}</div>
        <div class="date">{{ item.operDate }}</div>
      </div>
    </template>
    <template v-else>
      <div class="folder_name">
        <div class="file">{{ item.folderName }}</div>
        <div class="date">{{ item.operDate }}</div>
      </div>
    </template>
    <van-icon name="ellipsis" class="rightIcon" @click.native.stop="moreOpen" />
  </div>
</template>

<script>
import { tableRowIcon } from "@/CommonDP/utils/docPublic";

export default {
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    // logo图片地址
    logoSrc(item) {
      return tableRowIcon(item);
    },
    // 打开更多
    moreOpen() {
      this.$emit("moreOpen");
    }
  }
};
</script>

<style lang="scss" scoped>
.oneFileFolder {
  width: 100%;
  height: 70px;
  padding: 0 3vw;
  box-sizing: border-box;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;

  .leftIcon {
    width: 42px;
    height: 42px;
    padding: 5px;
    margin-bottom: 2px;
  }

  .folder_name {
    width: calc(100% - 75px);
    height: 50px;
    overflow-x: overlay !important;
    overflow-x: auto;

    .file {
      font-size: 16px;
      line-height: 20px;
      color: var(--key-color);
      white-space: nowrap;
      margin-top: 6px;
    }
    .isExpired {
      color: var(--info-color)9 !important;
    }
    .date {
      font-size: 13px;
      line-height: 16px;
      color: var(--info-color)9;
      white-space: nowrap;
    }
  }

  .rightIcon {
    padding: 6px;
    font-size: 18px;
  }
}
</style>
